import React from 'react';
import Bio from '../sections/Bio';
import Skillset from '../sections/Skillset';

const About = () => (
  <section id="about">
    <h1 className="heading">About Me</h1>
    <Bio />
    <h1 className="heading">Skill Set</h1>
    <Skillset skills={skills} />
  </section>
);

const skills = [
  { id: 1, label: 'HTML', value: '95%', width: '75%' },
  { id: 2, label: 'CSS', value: '98%', width: '78%' },
  { id: 3, label: 'JS', value: '92%', width: '72%' },
  { id: 4, label: 'Node', value: '80%', width: '60%' },
  { id: 5, label: 'React', value: '92%', width: '72%' },
  { id: 6, label: 'MongoDB', value: '80%', width: '60%' },
  { id: 7, label: 'Java', value: '50%', width: '30%' },
  { id: 8, label: 'Python', value: '70%', width: '50%' },
  { id: 9, label: 'Sass', value: '80%', width: '60%' },
  { id: 10, label: 'Bootstrap', value: '90%', width: '70%' },
];

export default About;
